// 首页 Fitting 区域展示的四张精选图片，资源集中放在 assets/ 下。
export const heroLooks = [
  {
    image: '/assets/fitting-1.jpg',
    title: 'Look 1 - Feather',
    description: 'white feathered full-length coat'
  },
  {
    image: '/assets/fitting-2.jpg',
    title: 'Look 2 - Eyelet',
    description: 'white draped eyelet coatdress'
  },
  {
    image: '/assets/fitting-3.jpg',
    title: 'Look 3 - Cocoon',
    description: 'sculptural charcoal full-length coat'
  },
  {
    image: '/assets/fitting-4.jpg',
    title: 'Look 4 - Cylinder',
    description: 'white sculptural cylindrical coat dress'
  }
];

/**
 * Fitting lookbook 的 30 套造型数据。
 *
 * 数组第一项是文件编号，真实图片路径为 /assets/fitting-looks/look-xx.jpg；
 * 第二项是展示标题；第三项是简短描述。
 * 这里先用紧凑数组维护内容，再 map 成页面更好使用的对象结构。
 */
export const fittingLooks = [
  ['28', 'Feather', 'white feathered full-length coat'],
  ['29', 'Eyelet', 'white draped eyelet coatdress'],
  ['30', 'Cocoon', 'sculptural charcoal full-length coat'],
  ['27', 'Cylinder', 'white sculptural cylindrical coat dress'],
  ['01', 'Bubble', 'translucent bubbled jacket, wide-leg trousers'],
  ['02', 'Mist', 'translucent zip-front top, full-length trousers'],
  ['03', 'Veil', 'sheer black layered outerwear, quilted short bottoms'],
  ['04', 'Mottle', 'printed tailored jacket, wide-leg trousers'],
  ['05', 'Ember', 'red tailored jacket, wide-leg trousers'],
  ['06', 'Cloud', 'white textured jacket, wide-leg trousers'],
  ['07', 'Smoke', 'silver tailored blazer, printed wide-leg trousers'],
  ['08', 'Sheer', 'sheer printed tailored jacket, matching shorts'],
  ['09', 'Restraint', 'white sleeveless top, ruched fitted trousers'],
  ['10', 'Satin', 'satin tailored jacket, cutout waistband trousers'],
  ['11', 'Bleach', 'bleached tailored blazer, washed wide-leg denim'],
  ['12', 'Carrier', 'cream sculptural coat, oversized eyelet tote'],
  ['13', 'Static', 'black eyelet leather vest, leather shorts'],
  ['14', 'Friction', 'sleeveless leather outer layer, zip-front wide-leg trousers'],
  ['15', 'Thorn', 'black sculptural grommet top, zip-detail trousers'],
  ['16', 'Contain', 'distressed sleeveless top, fitted trousers'],
  ['17', 'Ink', 'white tailored blazer with black textured applique, wide-leg trousers'],
  ['18', 'Drift', 'black sheer sleeveless top, silver textured shorts'],
  ['19', 'Divide', 'black sculptural coat, contrast wide-leg trousers'],
  ['20', 'Rift', 'cropped black zip jacket, wide zip-front culottes, distressed tote'],
  ['21', 'Poise', 'white tailored suit, sculpted chest and trouser panels'],
  ['22', 'Slit', 'tied printed shirt, glossy wide-leg trousers'],
  ['23', 'Cut', 'black sleeveless zip top, cutout zip trousers'],
  ['24', 'Shade', 'sheer black outer layer over metallic column dress'],
  ['25', 'Burst', 'black padded sculptural vest, draped printed skirt, oversized bag'],
  ['26', 'Dusk', 'pale long coat, printed top, wide-leg trousers']
].map(([image, title, description], index) => ({
  number: index + 1,
  image: `/assets/fitting-looks/look-${image}.jpg`,
  title,
  description
}));
